import Api from "@/repository/api";

import {
    IProductsTaxSystemRepository,
} from "@/repository/warehouse/TaxSystem/TaxSystemRepository.types"
import {IProductsTaxSystemItem, ProductsTaxSystemResponse} from "@/entity/warehouse/Products/TaxSystem/TaxSystem.types";
import ProductsTaxSystemTypes from "@/entity/warehouse/Products/TaxSystem/TaxSystem";

export class ProductsTaxSystemRepository implements IProductsTaxSystemRepository{
    async fetchAll(): Promise< IProductsTaxSystemItem[]> {
        const response = await Api.get('/tax_system/get');
        const responseData = response.data as ProductsTaxSystemResponse[];
        return responseData.map((data: ProductsTaxSystemResponse) => new ProductsTaxSystemTypes(data));
    }

}